export default __webpack_public_path__ + "443e2d80daec6a8dc7eb8c434dcca4ca.png";